import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Stepper,
  Step,
  StepLabel
} from "@mui/material";
import { fontfamily, primaryColor, primaryColorDark, secondaryColor } from "../../Util/UtilColorPalate";
import logo from "../../Assets/bigfive_logo.png";
import UserDetails from "../UserDetails/UserDetails";
import Checkout from "../Checkout/Checkout";
import DomainSelection from "../DomainSelection/DomainSelection";
import ProductSelection from "../ProductSelection/ProductSelection";
import { onboardingGetApi } from "../../Util/UtilAPi";

const OnboardingProcess2 = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [completedTabs, setCompletedTabs] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({
    title: "Mr.",
    firstName: "",
    lastName: "",
    contactNumber: "",
    mobile: "",
    countryCode: "+1",
    countryCode2: "+1",
    companyName: "",
    emailAddress: "",
    currency: "USD - $",
    method: [],
    consentProvided: true,
  });
  const [dealLineItems, setDealLineItems] = useState([]);
  const [domainselection, setDomainSelection] = useState({
    name: "",
    price: 0,
  });
  const [selectedItems, setSelectedItems] = useState({
    selection: "", // "product" or "package"
    selectedProducts: [], // Array of selected products or packages
  });
  const [selectedDomain, setSelectedDomain] = useState({
    name: "",
    price: 0,
  });
  const [companyCurrency, setCompanyCurrency] = useState("ZAR");
  const [checkoutDetails, setCheckoutDetails] = useState({
    title: "",
    fullname: "",
    phone: "",
    mobile: "",
    companyname: "",
    email: "",
    currency: "",
    paymentCurrency: "",
    orgCurrency: "",
    stage: ""
  });
  const [productDetails, setProductDetails] = useState([])
  const [includeDomain, setIncludeDomain] = useState(false); // State for domain purchase checkbox

  useEffect(() => {
    fetchDetails();
  }, [activeTab, userDetails]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // md and up for desktop (vertical)
  const fetchDetails = async () => {
    // const dealId = localStorage.getItem("deal");
    if (userDetails?.data?.email && activeTab!==0) {

      const payload = {
        email: userDetails?.data?.email
      }
      try {
        const response = await onboardingGetApi(payload);
        
        setCheckoutDetails({
          title: response.data.deal.title,
          fullname: response.data.deal.clientcontact.name,
          phone: response.data.deal.phone,
          mobile: response.data.deal.mobile,
          companyname: response.data.deal.clientdealid.name,
          email: response.data.deal.email,
          currency: response?.data?.leads?.currency?.name,
          paymentCurrency: companyCurrency || "INR",
          orgCurrency: response.data.companycurrency,
          stage: response.data.deal.stage.name
        })
        if (response.data.deal.stage.name === "Closed won") {
          setTimeout(() => {
            window.open("https://crm.bigfivecrm.com/", "_blank");
          }, 2000);
          setActiveTab(0)
        }

        setDealLineItems(response.data.deallineitems);
        // setSelectedItems(response.data.deallineitems)
        setDomainSelection({
          name: response.data.domain,
          price: 1
        })
      }
      catch (error) {
        console.log(error)
      }
    }
  }
  console.log(checkoutDetails, "currency fieldffff")

  const getTabs = () => {
    const baseTabs = [
      {
        label: "Company Info",
        subHeading: "Complete your company profile",
        component: (
          <UserDetails
            companyDetails={companyDetails}
            fetchDetails={fetchDetails}
            checkoutDetails={checkoutDetails}
            onNext={({ payload, currency }) => {
              setUserDetails(payload);
              setCompanyCurrency(currency);
              setCompletedTabs([...completedTabs, activeTab]);
              setActiveTab(1);
            }}
          />
        ),
      },
      {
        label: "Select Product",
        subHeading: "Choose the perfect solution for your needs",
        component: (
          <ProductSelection
            companyCurrency={companyCurrency}
            productSelection={dealLineItems}
            checkoutDetails={checkoutDetails}
            onPrevious={() => {
              setActiveTab(0)
              fetchDetails()
            }}
            // fetchDetails={fetchDetails}
            onNext={({ selectedItems, productDetails, includeDomain, paymentCurrency }) => {
              setSelectedItems(selectedItems);
              setProductDetails(productDetails);
              setIncludeDomain(includeDomain);
              setCompanyCurrency(paymentCurrency)
              setCompletedTabs([...completedTabs, activeTab]);
              setActiveTab(includeDomain ? 2 : 2); // Skip domain if not included
            }}
          />
        ),
      },
      ...(includeDomain
        ? [
          {
            label: "Select Domain",
            subHeading: "Choose a domain name to enhance your business",
            component: (
              <DomainSelection
                onPrevious={() => {
                  setIncludeDomain(false)
                  setActiveTab(1)
                }}
                userDetails={userDetails.data}
                onNext={(updatedDomain) => {
                  console.log(updatedDomain, includeDomain, "selecftfbhh")
                  setSelectedDomain(updatedDomain)
                  setCompletedTabs([...completedTabs, activeTab]);
                  setActiveTab(3);
                }}
                selectedItems={selectedItems}
                paymentCurrency={companyCurrency}
              />
            ),
          },
        ]
        : []),
      {
        label: "Checkout",
        subHeading: "Review your order and complete your purchase",
        component: (
          <Checkout
            onPrevious={({ domain }) => {
              if (includeDomain) {
                setActiveTab(2); // Go back to domain if included
              } else {
                setActiveTab(1);
              }
              fetchDetails();
            }}
            fetchDetails={fetchDetails}
            companyInfo={checkoutDetails}
            selectedItems={dealLineItems}
            domainSelection={domainselection}
            currency={companyCurrency}
            selectedDomain={includeDomain ? selectedDomain : null}
            onNext={() => {
              setCompletedTabs([...completedTabs, activeTab]);
            }}
          />
        ),
      },
    ];

    return baseTabs;
  };
console.log(productDetails,"details of productttt")
  // Use getTabs() instead of a static tabs array
  const tabs = getTabs();

  // Adjust activeTab index for checkout if domain is included
  const checkoutIndex = includeDomain ? 3 : 2;
  if (activeTab === checkoutIndex && !tabs[checkoutIndex]) {
    // Fallback if tabs length changes
    setActiveTab(tabs.length - 1);
  }

  return (
    <Box sx={styles.pageContainer}>
      {/* Mobile/Desktop Sidebar - Vertical Stepper (Hidden on Mobile) */}
      {!isMobile && (
        <Box sx={styles.leftSection}>
          <Box sx={{ textAlign: "center" }}>
            <img
              src={logo}
              alt="BigFive"
              style={{
                width: "100%",
                maxWidth: "140px",
                marginBottom: "20px",
              }}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Stepper
              activeStep={activeTab}
              orientation="vertical"
              sx={styles.stepperVertical}
            >
            {tabs.map((tab, index) => (
  <Step key={index} completed={completedTabs.includes(index)}>
    <StepLabel StepIconProps={{ classes: { root: styles.stepIcon } }}>
      <Typography
        sx={{
          ...styles.stepLabel,
          fontWeight: activeTab === index ? 700 : 500,
        }}
      >
        {tab.label}
      </Typography>
    </StepLabel>
  </Step>
))}
            </Stepper>
          </Box>
        </Box>
      )}

      {/* Main Content Area */}
      <Box sx={styles.rightSection}>
        {/* Mobile Header with Logo and Title */}
        {isMobile && (
          <Box sx={styles.mobileHeader}>
            <div
              style={{
                width: "100%",
                marginBottom: "20px",
                padding: "10px",
                borderRadius: "10px",
                textAlign: "center",
              }}
            >
              <img
                src={logo}
                alt="BigFive"
                style={{ maxWidth: "120px", marginBottom: "5px" }}
              />
            </div>
            <Typography variant="h5" sx={styles.heading}>
              {tabs[activeTab]?.label}
            </Typography>
            <Typography variant="subtitle1" sx={styles.subHeading}>
              {tabs[activeTab]?.subHeading}
            </Typography>
          </Box>
        )}

        {/* Horizontal Stepper for Mobile/Tablet */}
        {isMobile && (
          <Box sx={styles.mobileStepperContainer}>
            <Stepper
              activeStep={activeTab}
              orientation="horizontal"
              alternativeLabel
              sx={styles.stepperHorizontal}
            >
            {tabs.map((tab, index) => (
  <Step key={index} completed={completedTabs.includes(index)}>
    <StepLabel StepIconProps={{ classes: { root: styles.stepIconMobile } }}>
      <Typography
        sx={{
          ...styles.stepLabelMobile,
          fontWeight: activeTab === index ? 700 : 500,
        }}
      >
        {tab.label}
      </Typography>
    </StepLabel>
  </Step>
))}
            </Stepper>
          </Box>
        )}

        {/* Non-Mobile Header (Desktop) */}
        {!isMobile && (
          <>
            <Typography variant="h3" sx={styles.heading} fontFamily={fontfamily}>
              {tabs[activeTab]?.label}
            </Typography>
            <Typography variant="h6" sx={styles.subHeading}>
              {tabs[activeTab]?.subHeading}
            </Typography>
          </>
        )}

        {/* Content Box */}
        <Box
          sx={{
            mt: isMobile ? 1 : 4,
            mx: isMobile ? 1 : 2,
            mb: 2,
            p: isMobile ? 2 : 4,
            backgroundColor: secondaryColor,
            borderRadius: 3,
            overflowY: "auto",
            maxHeight: isMobile ? "calc(100vh - 200px)" : "auto", // Prevent overflow on mobile
          }}
        >
          {tabs[activeTab]?.component}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    height: "100vh",
    backgroundColor: primaryColor,
    flexDirection: { xs: "column", md: "row" }, // Column on mobile/tablet, row on desktop
    overflow: "hidden",
  },
  leftSection: {
    width: { md: "20%" }, // Only on desktop
    backgroundColor: secondaryColor,
    padding: "30px",
    boxShadow: "2px 0 10px rgba(0, 0, 0, 0.1)",
    display: { xs: "none", md: "flex" }, // Hidden on mobile/tablet, flex for centering
    flexDirection: "column",
    alignItems: "center",
    overflowY: "auto",
  },
  rightSection: {
    width: { xs: "100%", md: "80%" },
    p: { xs: 1, md: 4 },
    backgroundColor: primaryColor,
    overflowY: "auto",
    flex: 1,
  },
  mobileHeader: {
    textAlign: "center",
    mb: 1,
    px: 2,
  },
  mobileStepperContainer: {
    mb: 3,
    px: 2,
    display: "flex",
    justifyContent: "center",
  },
  stepperVertical: {
    width: "100%",
    maxWidth: "300px", // Constrain width for better centering
    fontFamily: `${fontfamily} !important`,
    "& .MuiStepConnector-root": {
      marginLeft: "10px",
      "& .MuiStepConnector-line": {
        borderColor: "#bdbdbd",
        borderWidth: "2px",
        minHeight: 50,
        transition: "border-color 0.3s ease-in-out",
      },
    },
    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
      borderColor: primaryColorDark,
    },
    "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
      borderColor: "#388e3c",
    },
    "& .MuiStepLabel-root": {
      marginLeft: 0,
    },
    "& .MuiStepLabel-label": {
      fontSize: "0.9rem",
      fontWeight: 500,
      color: "#424242",
      transition: "color 0.3s ease-in-out",
      fontFamily: `${fontfamily} !important`,
      textAlign: "left",
    },
    "& .MuiStepLabel-label.Mui-active": {
      color: primaryColorDark,
      fontWeight: "bold",
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "#388e3c",
      fontWeight: 500,
    },
    "& .MuiStepIcon-root": {
      color: "#757575",
      fontSize: "1.5rem",
      transition: "color 0.3s ease-in-out",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: primaryColorDark,
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "#388e3c",
    },
  },
  stepperHorizontal: {
    width: "100%",
    maxWidth: "600px", // Constrain width for better centering on mobile
    fontFamily: `${fontfamily} !important`,
    "& .MuiStepConnector-root": {
      "& .MuiStepConnector-line": {
        borderColor: "#bdbdbd",
        borderWidth: "2px",
        minHeight: 8,
        transition: "border-color 0.3s ease-in-out",
      },
    },
    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
      borderColor: primaryColorDark,
    },
    "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
      borderColor: "#388e3c",
    },
    "& .MuiStepLabel-label": {
      fontSize: { xs: "0.7rem", sm: "0.8rem" },
      fontWeight: 500,
      color: "#424242",
      transition: "color 0.3s ease-in-out",
      fontFamily: `${fontfamily} !important`,
    },
    "& .MuiStepLabel-label.Mui-active": {
      color: "black",
      fontWeight: 600,
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "#388e3c",
      fontWeight: 500,
    },
    "& .MuiStepIcon-root": {
      color: "#757575",
      fontSize: { xs: "1.2rem", sm: "1.4rem" },
      transition: "color 0.3s ease-in-out",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: primaryColorDark,
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "#388e3c",
    },
  },
  stepIcon: {
    fontSize: "1.5rem !important",
  },
  stepIconMobile: {
    fontSize: { xs: "1.2rem", sm: "1.4rem" } + " !important",
  },
  stepLabel: {
    fontSize: "1.4rem",
    fontWeight: 500,
    fontFamily: `${fontfamily} !important`,
  },
  stepLabelMobile: {
    fontSize: { xs: "0.7rem", sm: "0.8rem" },
    fontWeight: 500,
    fontFamily: `${fontfamily} !important`,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  heading: {
    mb: 1,
    color: "white",
    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2.5rem" },
    fontWeight: 600,
    fontFamily: fontfamily,
    textAlign: { xs: "center", md: "left" },
  },
  subHeading: {
    mb: 2,
    color: "white",
    fontSize: { xs: "0.875rem", sm: "1rem", md: "1.25rem" },
    fontFamily: fontfamily,
    opacity: 0.9,
    textAlign: { xs: "center", md: "left" },
  },
};

export default OnboardingProcess2;